export const PLAN_BENEFIT_TYPE_POLICY = {keyFields: false};
// Shared benefit structure: identity/order remain in plans; wording lives in translations.
export const PLAN_BENEFIT_OPTIONS = [
  {
    "key": "billing:planBenefit_unlimitedMessages",
    "english": "Unlimited messages"
  },
  {
    "key": "billing:planBenefit_limitedMessages",
    "english": "Limited messages"
  },
  {
    "key": "billing:planBenefit_reminders",
    "english": "Reminders"
  },
  {
    "key": "billing:planBenefit_limitedStorage",
    "english": "Limited storage space"
  },
  {
    "key": "billing:planBenefit_limitedAi",
    "english": "Limited AI usage"
  },
  {
    "key": "billing:planBenefit_aiMultiplier",
    "english": "{{value}}x AI usage"
  },
  {
    "key": "billing:planBenefit_kanban",
    "english": "Kanban view"
  },
  {
    "key": "billing:planBenefit_smartSearch",
    "english": "Smart filters & search"
  },
  {
    "key": "billing:planBenefit_deviceSync",
    "english": "Sync across all devices"
  },
  {
    "key": "billing:planBenefit_cloudBackup",
    "english": "Cloud backup & encryption"
  },
  {
    "key": "billing:planBenefit_unlimitedFolders",
    "english": "Unlimited folders & subfolders"
  },
  {
    "key": "billing:planBenefit_storage",
    "english": "{{value}} storage space"
  },
  {
    "key": "billing:planBenefit_fileUpload",
    "english": "{{value}} file upload"
  },
  {
    "key": "billing:planBenefit_summaries",
    "english": "AI Summaries"
  },
  {
    "key": "billing:planBenefit_transcription",
    "english": "Voice message transcription"
  },
  {
    "key": "billing:planBenefit_bookmarks",
    "english": "Intelligent Bookmarks"
  },
  {
    "key": "billing:planBenefit_imageTags",
    "english": "AI Image tagging"
  },
  {
    "key": "billing:planBenefit_ocr",
    "english": "Image text recognition"
  },
  {
    "key": "billing:planBenefit_integrations",
    "english": "Integrations"
  },
  {
    "key": "billing:planBenefit_plugins",
    "english": "Plugins"
  },
  {
    "key": "billing:planBenefit_linkPreviews",
    "english": "Rich link previews"
  },
  {
    "key": "billing:planBenefit_luckyActions",
    "english": "Lucky Actions"
  },
  {
    "key": "billing:planBenefit_lookUp",
    "english": "Look Up"
  },
  {
    "key": "billing:planBenefit_messageCount",
    "english": "{{value}} messages"
  },
  {
    "key": "billing:planBenefit_everything",
    "english": "Everything in {{value}}, plus"
  },
  {
    "key": "billing:planBenefit_prioritySupport",
    "english": "Priority support"
  },
  {
    "key": "billing:planBenefit_earlyAccess",
    "english": "Early access to new features"
  }
];
export function migratePlanBenefits(description) {
    return String(description || '').split(/•|\n/).map(s => s.trim()).filter(Boolean).map((text, index) => {
        let match = PLAN_BENEFIT_OPTIONS.find(item => item.english === text);
        let value = null;
        const patterns = [
            ['storage', /^(\d+(?:\.\d+)?\s*(?:MB|GB|TB)) storage space$/i],
            ['fileUpload', /^(\d+(?:\.\d+)?\s*(?:MB|GB|TB)) file upload$/i],
            ['aiMultiplier', /^(\d+)x AI usage$/i],
            ['messageCount', /^(\d+) messages$/i],
            ['everything', /^Everything in (.+), plus:?$/i]
        ];
        for (const [key, regex] of patterns) {
            const result = text.match(regex);
            if (result) {match = PLAN_BENEFIT_OPTIONS.find(item => item.key === `billing:planBenefit_${key}`); value = result[1]; break;}
        }
        return {id: `benefit-${index + 1}`, kind: text.endsWith(':') || /^everything/i.test(text) ? 'heading' : 'benefit',
            translationKey: match?.key || null, fallback: text, value, valueSource: null};
    });
}
export function formatPlanCapacity(gb) {
    if (gb >= 1000) return `${+(gb / 1000).toFixed(2)} TB`;
    if (gb > 0 && gb < 1) return `${+(gb * 1000).toFixed(2)} MB`;
    return `${+Number(gb).toFixed(2)} GB`;
}
export function renderPlanBenefits(plan, translate, language = translate.lng || 'en') {
    if (plan?.benefitList) {
        const locale = String(language);
        const translations = Object.fromEntries((plan.benefitList.translations || []).map(entry => [entry.language, entry.lines]));
        const list = translations[locale] || translations[locale.split('-')[0]] || plan.benefitList[locale.split('-')[0]] || translations.en || plan.benefitList.en || [];
        return list.map((text, index) => ({id: `line-${index}`, kind: text.endsWith(':') ? 'heading' : 'benefit', text}));
    }
    const rows = Array.isArray(plan?.benefits) ? plan.benefits : migratePlanBenefits(plan?.description);
    return rows.map(row => {
        let value = row.value;
        if (row.valueSource && Number.isFinite(Number(plan?.[row.valueSource])) && plan?.[row.valueSource] != null) {
            value = ['maxStorage', 'maxFileSize'].includes(row.valueSource)
                ? formatPlanCapacity(Number(plan[row.valueSource])) : String(plan[row.valueSource]);
        }
        const option = PLAN_BENEFIT_OPTIONS.find(item => item.key === row.translationKey);
        // For registered templates, the English default must interpolate the current limit too.
        const text = row.translationKey ? translate(row.translationKey, {value, defaultValue: option?.english || row.fallback}) : row.fallback;
        return {...row, text};
    });
}
